import { init, register, getLocaleFromNavigator } from 'svelte-i18n';
import { userLocale } from './stores/localeStore';

register('en', () => import('../locales/en.json'));
register('de', () => import('../locales/de.json'));
register('fr', () => import('../locales/fr.json'));
register('es', () => import('../locales/es.json'));
register('it', () => import('../locales/it.json'));
register('pt', () => import('../locales/pt.json'));
register('ru', () => import('../locales/ru.json'));

let initialLocale = 'en';

if (typeof window !== 'undefined') {
	initialLocale = userLocale.get();
}

init({
	fallbackLocale: 'en',
	initialLocale: initialLocale,
});